import { create } from 'zustand';

import type { KnowledgeBase } from '@/types/knowledge.type';

type KnowledgeModalsState = {
  selectedKnowledgeBase: KnowledgeBase | null;
  selectedDocument: string | null;
  isDocumentDetailsOpen: boolean;

  selectKnowledgeBase: (kb: KnowledgeBase) => void;
  clearSelectedKnowledgeBase: () => void;
  openDocumentDetails: (filePath: string) => void;
  closeDocumentDetails: () => void;
};

export const useKnowledgeModalsStore = create<KnowledgeModalsState>(set => ({
  selectedKnowledgeBase: null,
  selectedDocument: null,
  isDocumentDetailsOpen: false,

  selectKnowledgeBase: kb => set({ selectedKnowledgeBase: kb }),
  clearSelectedKnowledgeBase: () => set({ selectedKnowledgeBase: null }),

  openDocumentDetails: filePath =>
    set({
      selectedDocument: filePath,
      isDocumentDetailsOpen: true,
    }),

  closeDocumentDetails: () =>
    set({
      isDocumentDetailsOpen: false,
    }),
}));
